// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "Container-module--cds--assistive-text--00faf";
export var cdsHideFeedback = "Container-module--cds--hide-feedback--eaeb4";
export var cdsShowFeedback = "Container-module--cds--show-feedback--18884";
export var cdsSkeleton = "Container-module--cds--skeleton--485cc";
export var cdsVisuallyHidden = "Container-module--cds--visually-hidden--ce47f";
export var overlay = "Container-module--overlay--2b409";
export var visible = "Container-module--visible--c4692";